const ios = {
  getUserInfo: '0.0.0',
  getLoc: '0.0.0',
  getQueryParam: '0.0.0',
  isVerBigEqNow: '0.0.0',
  analyse: '0.0.0',
  jumpToProfile: '0.0.0',
  getClientInfo: '3.1.3',
  jumpToPay: '3.1.3',
  jumpToParty: '3.1.3',
  backToPrePage: '3.1.9',
  signOut: '3.2.1',
  stopBackBehavior: '3.2.1',
  previewEffect: '3.2.1'
}
const android = {
  getUserInfo: '0.0.0',
  getLoc: '0.0.0',
  getQueryParam: '0.0.0',
  isVerBigEqNow: '0.0.0',
  analyse: '0.0.0',
  jumpToProfile: '0.0.0',
  getClientInfo: '3.8.9.3',
  jumpToPay: '3.8.9.3',
  jumpToParty: '3.8.9.3',
  backToPrePage: '3.8.9.8',
  signOut: '3.9.0.1',
  stopBackBehavior: '3.9.0.1',
  previewEffect: '3.9.0.1'
}

const compareVersion = (targetVer, minVer) => {
  console.log('targetVer, minVer', targetVer, minVer)
  if (!targetVer || !minVer) {
    console.error('ver 参数异常')
    return false
  }
  targetVer = targetVer.split('.')
  minVer = minVer.split('.')
  const n = Math.max(targetVer.length, minVer.length)
  for (let i = 0; i < n; i++) {
    const target = (targetVer[i] === undefined) ? 0 : parseInt(targetVer[i])
    const min = (minVer[i] === undefined) ? 0 : parseInt(minVer[i])
    if (target > min) {
      return true
    } else if (target < min) {
      return false
    }
  }
  return true
}
const ApiUtils = {
  iosVer: ios,
  androidVer: android,
  compareVersion
}
export default ApiUtils
